module.exports = __webpack_public_path__ + "static/media/sumdog-logo.f0310524.png";